import { Router } from "express";

import { studentDashboardController } from "../controllers/student-dashboard-controller";
import {
  authenticate,
  requireEmailVerification,
} from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

/**
 * STUDENT DASHBOARD ROUTES
 * Base path: /api/v1/student/dashboard
 */

// Apply authentication and student role requirement
router.use(authenticate);
router.use(requireEmailVerification);
router.use(requireRole(["student"]));

/**
 * @route   GET /api/v1/student/dashboard
 * @desc    Get complete student dashboard data
 * @access  Private (Student only)
 * @returns {Object} Dashboard data including:
 *          - Student profile
 *          - Overview stats (enrolled classes, pending assignments, etc.)
 *          - Upcoming quizzes
 *          - Pending assignments
 *          - Recent results (graded assignments & quizzes)
 *          - Progress report (monthly performance chart)
 *          - Recent notifications
 *          - Attendance statistics
 *          - Active alerts
 */
router.get("/", (req, res) =>
  studentDashboardController.getDashboard(req, res),
);

export default router;
